// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item-row {
  background: white;
  box-shadow: 0px 0px 20px 0px rgba(13, 71, 161, 0.1490196078);
  margin-bottom: 8px;
  padding: 5px;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  height: 100%;
  display: block;
}
.item-row .not-order-item {
  display: flex;
  justify-content: center;
  align-items: center;
}
.item-row .not-order-item .text-not-visible {
  opacity: 1;
  background: rgb(169, 169, 169);
  box-shadow: 0px 0px 20px 0px rgba(13, 71, 161, 0.1490196078);
  color: white;
  padding: 3px 5px;
  border-radius: 2px;
  font-size: 14px;
}
.item-row .img-block {
  position: relative;
}
.item-row .img-block .amount-in-basket {
  position: absolute;
  display: flex;
  align-items: center;
  background: var(--ion-color-secondary);
  border-radius: 20px;
  top: 5px;
  left: 5px;
  height: 20px;
}
.item-row .img-block .amount-in-basket ion-icon {
  width: 20px;
  height: 20px;
}
.item-row .img-block .amount-in-basket p {
  padding: 0px 10px 0px 5px;
  color: white;
  font-family: AppFontBold, sans-serif;
}
.item-row .img-block .section_favourite {
  position: absolute;
  bottom: 0px;
  left: 0px;
  background: var(--ion-color-primary);
  border-top-right-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3px;
}
.item-row .img-block .section_favourite ion-icon {
  zoom: 1.3;
}
.item-row .img-block .tags_article {
  position: absolute;
  z-index: 99;
  zoom: 3;
  right: 5%;
  top: 5%;
}
.item-row .item-image {
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-radius: 10px;
  overflow: hidden;
  margin: 0px !important;
  min-height: 130px;
}
.item-row .item-image.default-image {
  padding: 20px;
  object-fit: contain;
}
@media (max-width: 992px) {
  .item-row .item-image {
    min-height: 110px;
  }
}
.item-row .item-text {
  padding: 20px 10px 5px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
}
.item-row .item-text .block_type {
  position: absolute;
  top: 10px;
  right: 0px;
  padding: 5px;
  box-shadow: 0px 0px 20px 0px rgba(13, 71, 161, 0.1490196078);
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  display: flex;
  align-items: center;
  z-index: 99;
}
.item-row .item-text .block_type ion-icon {
  zoom: 1.2;
  margin-right: 5px;
}

.item-name {
  font-size: 16px;
  line-height: var(--item-view-title-line-height);
  color: var(--ion-color-secondary);
  font-family: AppFontBold, sans-serif;
  margin-right: 65px;
  text-transform: capitalize;
}
.item-name ion-icon {
  width: 20px;
  height: 17px;
}

.item-info {
  padding-top: 10px;
  font-size: var(--item-view-info-font-size);
  line-height: var(--item-view-info-line-height);
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #899589;
}

.price-col {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 10px 10px 5px 0px;
  justify-content: flex-start;
}
.price-col .action-icon {
  width: 22px;
  height: 22px;
}
@media (min-width: 991px) {
  .price-col .action-icon {
    display: none;
  }
}

.price {
  color: var(--ion-color-secondary);
  font-family: AppFontBold, sans-serif;
  font-size: 16px;
}
@media (min-width: 991px) {
  .price {
    margin-bottom: 2px;
  }
}
@media (max-width: 992px) {
  .price {
    text-align: right;
  }
}

.small-screen {
  display: flex;
  padding: 0px;
}

.measurment_text {
  font-family: AppFont, sans-serif;
  font-size: 10px;
  color: #9f9f9f;
  text-align: right;
  margin-top: 7px;
}
@media (max-width: 992px) {
  .measurment_text {
    text-align: left;
  }
}

.vat {
  color: black;
  font-size: 10px;
}

.vegan-block {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-right: 5px;
}
.vegan-block ion-img {
  width: 35px;
  height: 24px;
}
.vegan-block p {
  font-size: 8px;
  color: #7ea769;
}

.add-opacity {
  opacity: 0.6;
}

.price-wrapper {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-bottom: 5px;
  align-items: center;
}

.name-section {
  display: flex;
  flex-direction: column;
}`, "",{"version":3,"sources":["webpack://./src/app/components/item-view/item-view.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,iBAAA;EAEA,4DAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EAqGA,eAAA;EACA,YAAA;EACA,cAAA;AAtGD;AAAC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;AAEF;AAAE;EACC,UAAA;EAEA,8BAAA;EACA,4DAAA;EAEA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AAAH;AAGC;EACC,kBAAA;AADF;AAEE;EACC,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,sCAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;AAAH;AACG;EACC,WAAA;EACA,YAAA;AACJ;AACG;EACC,yBAAA;EACA,YAAA;EACA,oCAAA;AACJ;AAEE;EACC,kBAAA;EACA,WAAA;EACA,SAAA;EACA,oCAAA;EACA,6BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAAH;AACG;EACC,SAAA;AACJ;AAEE;EACC,kBAAA;EACA,WAAA;EACA,OAAA;EACA,SAAA;EACA,OAAA;AAAH;AAGC;EACC,YAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;AADF;AAEE;EACC,aAAA;EACA,mBAAA;AAAH;AC1EE;EDgED;IAaE,iBAAA;EACD;AACF;AAEC;EACC,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,kBAAA;AAAF;AACE;EACC,kBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,4DAAA;EACA,4BAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AACH;AAAG;EACC,SAAA;EACA,iBAAA;AAEJ;;AAMA;EACC,eAAA;EACA,+CAAA;EAEA,iCAAA;EACA,oCAAA;EACA,kBAAA;EACA,0BAAA;AAJD;AAMC;EACC,WAAA;EACA,YAAA;AAJF;;AAQA;EACC,iBAAA;EACA,0CAAA;EACA,8CAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;AALD;;AAQA;EACC,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,0BAAA;EACA,2BAAA;AALD;AAOC;EACC,WAAA;EACA,YAAA;AALF;AClJE;EDqJD;IAIE,aAAA;EAHD;AACF;;AAMA;EAEC,iCAAA;EACA,oCAAA;EACA,eAAA;AAJD;AC7JE;ED6JF;IAOE,kBAAA;EAHA;AACF;AC5JE;EDuJF;IAUE,iBAAA;EADA;AACF;;AAIA;EACC,aAAA;EACA,YAAA;AADD;;AAIA;EACC,gCAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;AADD;AC9KE;ED0KF;IAOE,gBAAA;EACA;AACF;;AACA;EACC,YAAA;EACA,eAAA;AAED;;AAAA;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAGD;AAFC;EACC,WAAA;EACA,YAAA;AAIF;AAFC;EACC,cAAA;EACA,cAAA;AAIF;;AADA;EACC,YAAA;AAID;;AAFA;EACC,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAKD;;AAHA;EACC,aAAA;EACA,sBAAA;AAMD","sourcesContent":["@import '../../../theme/mixins';\n\n.item-row {\n\tbackground: white;\n\t// border: var(--item-view-border);\n\tbox-shadow: 0px 0px 20px 0px #0d47a126;\n\tmargin-bottom: 8px;\n\tpadding: 5px;\n\tborder-radius: 10px;\n\toverflow: hidden;\n\tposition: relative;\n\t.not-order-item {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\n\t\t.text-not-visible {\n\t\t\topacity: 1;\n\n\t\t\tbackground: rgb(169, 169, 169);\n\t\t\tbox-shadow: 0px 0px 20px 0px #0d47a126;\n\n\t\t\tcolor: white;\n\t\t\tpadding: 3px 5px;\n\t\t\tborder-radius: 2px;\n\t\t\tfont-size: 14px;\n\t\t}\n\t}\n\t.img-block {\n\t\tposition: relative;\n\t\t.amount-in-basket {\n\t\t\tposition: absolute;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tbackground: var(--ion-color-secondary);\n\t\t\tborder-radius: 20px;\n\t\t\ttop: 5px;\n\t\t\tleft: 5px;\n\t\t\theight: 20px;\n\t\t\tion-icon {\n\t\t\t\twidth: 20px;\n\t\t\t\theight: 20px;\n\t\t\t}\n\t\t\tp {\n\t\t\t\tpadding: 0px 10px 0px 5px;\n\t\t\t\tcolor: white;\n\t\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\t}\n\t\t}\n\t\t.section_favourite {\n\t\t\tposition: absolute;\n\t\t\tbottom: 0px;\n\t\t\tleft: 0px;\n\t\t\tbackground: var(--ion-color-primary);\n\t\t\tborder-top-right-radius: 10px;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tpadding: 3px;\n\t\t\tion-icon {\n\t\t\t\tzoom: 1.3;\n\t\t\t}\n\t\t}\n\t\t.tags_article {\n\t\t\tposition: absolute;\n\t\t\tz-index: 99;\n\t\t\tzoom: 3;\n\t\t\tright: 5%;\n\t\t\ttop: 5%;\n\t\t}\n\t}\n\t.item-image {\n\t\theight: 100%;\n\t\twidth: 100%;\n\t\tobject-fit: cover;\n\t\tborder-radius: 10px;\n\t\toverflow: hidden;\n\t\tmargin: 0px !important;\n\t\tmin-height: 130px;\n\t\t&.default-image {\n\t\t\tpadding: 20px;\n\t\t\tobject-fit: contain;\n\t\t}\n\t\t@include mobile {\n\t\t\tmin-height: 110px;\n\t\t}\n\t}\n\n\t.item-text {\n\t\tpadding: 20px 10px 5px;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: space-between;\n\t\tposition: relative;\n\t\t.block_type {\n\t\t\tposition: absolute;\n\t\t\ttop: 10px;\n\t\t\tright: 0px;\n\t\t\tpadding: 5px;\n\t\t\tbox-shadow: 0px 0px 20px 0px #0d47a126;\n\t\t\tborder-top-left-radius: 10px;\n\t\t\tborder-bottom-left-radius: 10px;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tz-index: 99;\n\t\t\tion-icon {\n\t\t\t\tzoom: 1.2;\n\t\t\t\tmargin-right: 5px;\n\t\t\t}\n\t\t}\n\t}\n\tcursor: pointer;\n\theight: 100%;\n\tdisplay: block;\n}\n.item-name {\n\tfont-size: 16px;\n\tline-height: var(--item-view-title-line-height);\n\n\tcolor: var(--ion-color-secondary);\n\tfont-family: AppFontBold, sans-serif;\n\tmargin-right: 65px;\n\ttext-transform: capitalize;\n\n\tion-icon {\n\t\twidth: 20px;\n\t\theight: 17px;\n\t}\n}\n\n.item-info {\n\tpadding-top: 10px;\n\tfont-size: var(--item-view-info-font-size);\n\tline-height: var(--item-view-info-line-height);\n\tword-break: break-word;\n\tdisplay: -webkit-box;\n\t-webkit-line-clamp: 3;\n\t-webkit-box-orient: vertical;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\tcolor: #899589;\n}\n\n.price-col {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: flex-end;\n\tpadding: 10px 10px 5px 0px;\n\tjustify-content: flex-start;\n\n\t.action-icon {\n\t\twidth: 22px;\n\t\theight: 22px;\n\t\t@include desktop {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n.price {\n\t// margin-bottom: 12px;\n\tcolor: var(--ion-color-secondary);\n\tfont-family: AppFontBold, sans-serif;\n\tfont-size: 16px;\n\n\t@include desktop {\n\t\tmargin-bottom: 2px;\n\t}\n\t@include mobile {\n\t\ttext-align: right;\n\t}\n}\n\n.small-screen {\n\tdisplay: flex;\n\tpadding: 0px;\n}\n\n.measurment_text {\n\tfont-family: AppFont, sans-serif;\n\tfont-size: 10px;\n\tcolor: #9f9f9f;\n\ttext-align: right;\n\tmargin-top: 7px;\n\t@include mobile {\n\t\ttext-align: left;\n\t}\n}\n.vat {\n\tcolor: black;\n\tfont-size: 10px;\n}\n.vegan-block {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding-right: 5px;\n\tion-img {\n\t\twidth: 35px;\n\t\theight: 24px;\n\t}\n\tp {\n\t\tfont-size: 8px;\n\t\tcolor: #7ea769;\n\t}\n}\n.add-opacity {\n\topacity: 0.6;\n}\n.price-wrapper {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tpadding-bottom: 5px;\n\talign-items: center;\n}\n.name-section {\n\tdisplay: flex;\n\tflex-direction: column;\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
